import {mutations} from './mutations';
import {actions} from './actions';
import {getters} from './getters';

const state = {
    items: [],
    expire: null,
    loading: false,

    defaultSortBy: 'id',
    defaultSortDesc: true
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

